import { render, staticRenderFns } from "./OrgNotFound.vue?vue&type=template&id=13e6252b&"
import script from "./OrgNotFound.vue?vue&type=script&lang=js&"
export * from "./OrgNotFound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports